import { CommunicationSizeComponent, ComponentIds, Entity } from '@inter-ikea-core/core';
import { CoreApi, Product, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';

export const matchInteriorsToFrames = (products: Product[], entitiesInScene: Entity[]) => {
  const frames = entitiesInScene.filter(entity => {
    const productType = entity.getComponent<ProductInfoComponent>(ProductInfoComponent.id)
      ?.productType;
    return (
      entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID) &&
      productType &&
      ProductType.JONAXEL_FRAME === productType
    );
  });
  if (frames.length === 0) {
    return products;
  }
  const frameDepths = frames
    .map(
      frame =>
        frame.getComponent<CommunicationSizeComponent>(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)
          ?.size.depth
    )
    .filter((depth): depth is number => depth !== undefined);

  return products
    .map(product => {
      const interiorDepth = product.communicatedDimensions.depth;
      return frameDepths.includes(interiorDepth) ? product : null;
    })
    .filter((p): p is Product => p !== null);
};

export const matchFrames = (coreApi: CoreApi) => () => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) return false;
  return coreApi.entities.isProductType(selectedEntity, ProductType.JONAXEL_FRAME);
};
